import { newToolFilterOAuthMcp } from "../oauth.ts";

export const cloudflareObservabilityMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://developers.cloudflare.com/favicon.png",
  url: "https://observability.mcp.cloudflare.com/mcp",
  label: "Cloudflare Observability",
});
